import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { USER_ROLE } from 'api/users/users.model';
import Button from 'components/Buttons';
import ProtectedComponent from 'components/ProtectedComponent';
import SectionTitle from 'components/SectionTitle';
import { COMPANY } from 'models/company.model';

import CreateDocumentModal, { CreateRelatedDocumentModalProps } from './CreateDocumentModal';
import DocumentDetails from './DocumentDetails';

interface RelatedDocumentsProps extends Omit<CreateRelatedDocumentModalProps, 'onCloseModal'> {
  company: COMPANY;
}

const RelatedDocuments = (props: RelatedDocumentsProps) => {
  const { t } = useTranslation();

  const [isModalOpen, setModalOpen] = useState(false);

  const handleOpenModal = () => setModalOpen(true);

  const handleCloseModal = () => setModalOpen(false);

  return (
    <>
      <SectionTitle
        after={
          <ProtectedComponent
            role={(Object.keys(USER_ROLE) as USER_ROLE[]).filter((r) => r !== USER_ROLE.VISITOR)}
            company={props.company}
          >
            <Button type="primary" size="small" onClick={handleOpenModal}>
              {t('certificate.addRelatedDocument')}
            </Button>
          </ProtectedComponent>
        }
      >
        {t('certificate.relatedDocuments')}
      </SectionTitle>
      {props.history.map((document) => (
        <DocumentDetails key={document.documentBlockchainAddress} {...document} />
      ))}

      {isModalOpen && <CreateDocumentModal {...props} onCloseModal={handleCloseModal} />}
    </>
  );
};

export default RelatedDocuments;
